// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rO85AD52O0YZvq {
  display: flex;
  column-gap: var(--ds-space-100, 8px);
}
.rO85AD52O0YZvq.jVTzUGsFEBLlRE {
  margin: var(--ds-space-0, 0px) var(--ds-space-150, 12px);
}
.HEV7giQY94fKJT {
  display: flex;
  overflow-y: auto;
  column-gap: var(--ds-space-100, 8px);
  scrollbar-width: none;
}
`, ""]);
// Exports
export var wrapper = `rO85AD52O0YZvq`;
export var panel = `jVTzUGsFEBLlRE`;
export var buttons = `HEV7giQY94fKJT`;
export default ___CSS_LOADER_EXPORT___;
